// extracted by mini-css-extract-plugin
module.exports = {"CheckboxContainer":"📚4-7-0160dX","Checkbox":"📚4-7-03oxtH","Check":"📚4-7-01Rfli"};